<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<div class="driver-view">
  <div>
    <div class="heading">
      <h3>Trucks Category</h3>
    </div>
    <mat-divider></mat-divider>
    <form [formGroup]="addCategoryForm">
      <div class="input-fileds-container mt-0">
        <div class="group">
          <mat-form-field appearance="fill" floatLabel="always" class="mb-3">
            <mat-label>Truck Category Name</mat-label>
            <input
              type="text"
              matInput
              formControlName="truck_category_name"
              required
            />
            <!-- <mat-error>Please Enter Category Name</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Description</mat-label>
            <input
              type="text"
              matInput
              formControlName="category_description"
              required
            />
            <!-- <mat-error>Please Enter Descrption</mat-error> -->
          </mat-form-field>
          <div class="image-upload-view-area">
            <!-- <div [class.spinner]="categImageloading"></div> -->

            <div class="upload_image" *ngIf="uploadImg">
              <img src="{{ profileImage }}" class="upload_img_size" />
            </div>
            <div class="image-upload-area mt-3">
              <span
                *ngIf="profileImg"
                (click)="uploadImage.click()"
                class="image"
                ><img src="../../../assets/img/upload.svg" />
                <p>Upload Truck Image</p>
              </span>
              <img
                src="../../../assets/img/cross.svg"
                *ngIf="crossImg"
                (click)="removeImg()"
                class="cross-btn"
                alt=""
              />

              <input
                #uploadImage
                type="file"
                formControlName="category_image"
                (change)="onChange($event)"
                hidden
              />
            </div>
          </div>
        </div>
      </div>
      <!-- <i class="fa fa-spinner fa-spin"></i> -->
      <button
        type="submit"
        class="button buttonBlue"
        [class.spinner]="loading"
        [ngClass]="{ 'button-disabled': loading || !addCategoryForm.valid }"
        [disabled]="loading || !addCategoryForm.valid"
        (click)="addTruckCat($event)"
      >
        Add Truck Category
      </button>
    </form>
  </div>
</div>
